import { render } from "./MainBody.vue?vue&type=template&id=178431a0&scoped=true"
import script from "./MainBody.vue?vue&type=script&lang=js"
export * from "./MainBody.vue?vue&type=script&lang=js"

import "./MainBody.vue?vue&type=style&index=0&id=178431a0&lang=scss&scoped=true"

import exportComponent from "/Users/amina/Desktop/streamup_amina/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178431a0"]])

export default __exports__